import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';
import { specials } from '../data/specials';
export function SpecialsPage() {
  usePageMeta({
    title: "Current Specials — $50 Off Full Details | Mike's Pro Detail",
    description: "Limited-time mobile detailing specials in Ventura County: $50 off Full Details, $20 off Wash & Wax, $10 off Basic Wash (2 car minimum), and $40 off engine cleaning. Call or text 818-381-9905.",
    path: '/specials',
    breadcrumbName: 'Specials'
  });
  return <main data-id="element-1116" data-mp="iol8mfdbx2ux">
      <PageHeader breadcrumb="Specials" title="Current Specials" subtitle="Limited-time savings on our most popular mobile detailing services. Mention the special when you call, text, or request a quote." data-id="element-1117" data-mp="ip3e82lvstfi" />

      <section className="w-full bg-black py-16 px-4" data-id="element-1118" data-mp="2kfewrr1dusej">
        <div className="max-w-5xl mx-auto" data-id="element-1119" data-mp="2ki1a67ayg24o">
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-1120" data-mp="1ztzvutxyathz">
            {specials.map(special => <li key={special.service} className="flex flex-col bg-zinc-900/70 border-[5px] rounded-xl p-6" style={{
            borderColor: '#FFE81A'
          }} data-id="element-1121" data-mp="1v1zoigfjwybd">
                <p className="text-6xl font-black text-yellow-400 leading-none" data-id="element-1122" data-mp="1qyjuzsys3e2w">
                  {special.amount}
                  <span className="ml-2 text-3xl" data-id="element-1123" data-mp="1lzqj24z53v4u">OFF</span>
                </p>
                <h2 className="mt-4 text-2xl font-black uppercase text-white" data-id="element-1124" data-mp="2ir10ueri8tlx">
                  {special.service}
                </h2>
                <p className="mt-2 text-gray-300" data-id="element-1125" data-mp="29qvw6cdp49bg">{special.appliesTo}</p>
                {special.condition && <p className="mt-3 inline-block self-start px-3 py-1 bg-red-600 text-white text-sm font-black uppercase tracking-wide rounded" data-id="element-1126" data-mp="24sb5p4o8x407">
                    {special.condition}
                  </p>}
                <Link to={special.path} className="mt-auto pt-6 inline-flex items-center gap-2 text-yellow-400 font-black uppercase tracking-wider hover:text-yellow-300 transition-colors duration-150" data-id="element-1127" data-mp="tccrkme7nrs4">
                  {special.linkLabel}
                  <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-1128" data-mp="zsmdumhbxbyh" />
                </Link>
              </li>)}
          </ul>
        </div>
      </section>

      <CallCta title={<>
            Claim Your <span className="text-yellow-400" data-id="element-1130" data-mp="qr53lkqls4hp">Special</span>
          </>} subtitle="Call or text Mike, or request a quote online and mention the special you'd like." data-id="element-1129" data-mp="qs7qziopvosv" />
    </main>;
}